import { useMemo, useState } from 'react'
import PatrimoniosHttp from '../../../../services/api/https/patrimonio/patrimonio.http'
import { getTps } from '../../../../services/localstorage/localstorage.service'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  FETCH_INFO: 'Adquirindo informações',
}

const INITIAL_STATE = {
  transportadoras: [],
  modal: {
    show: false,
    data: null,
  },
  periodo: getPeriodoMesAtual(),
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function usePendenciasTransportadora() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getPendenciasPorTransportadora(selectedTp) {
        let tpsIds = []
        if (selectedTp === 0) {
          tpsIds.push(
            ...getTps()
              .filter(tp => tp.id !== 0)
              .map(tp => tp.id),
          )
        } else {
          tpsIds.push(selectedTp)
        }
        PatrimoniosHttp.fetchPendenciasPorTransportadora(tpsIds)
          .then(transportadoras =>
            setState(prevState => ({
              ...prevState,
              transportadoras: transportadoras,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.FETCH_INFO }))
      },

      onModalEvent(action, payload) {
        switch (action) {
          case 'save':
            setState(prevState => {
              prevState.modal.show = false
              prevState.modal.data = null
              return { ...prevState }
            })
            break

          case 'close':
            setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
            break

          default:
            break
        }
      },

      onNovoClick(selectedTp) {
        if (selectedTp) setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
        else
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um Operador Logístico' }))
      },

      onBtnPesquisarClick(dataInicial, dataFinal) {
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial, dataFinal },
          loadingMessage: LOAD_MESSAGE.FILTERING,
        }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onMenuItemClicked(item, transportadora) {
        switch (item) {
          case 'Pendencias':
            setState(prevState => ({ ...prevState, modal: { show: true, data: transportadora } }))
            break
          case 'Exportar':
            const colunas = [
              [
                'Op. Logístico',
                'Transportadora',
                'CNPJ',
                'Telefone',
                'Cidade',
                'Estado',
                'Patrimonio',
                'Qte',
              ],
            ]

            transportadora.consolidado.forEach(consolidado => {
              colunas.push([
                transportadora.tp_name,
                transportadora.nome,
                transportadora.cnpj,
                transportadora.telefone,
                transportadora.city,
                transportadora.state,
                consolidado.patrimonio_name,
                consolidado.saldo,
              ])
            })

            gerarArquivoExcel(
              'transportadora',
              colunas,
              `Pendencias_${transportadora.nome}_${new Date().toLocaleString().slice(0, 10)}.xlsx`,
            )
            break

          default:
            break
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
